import { db } from "../../firebase/index";
import { FirebaseTimestamp } from "../../firebase/index";

export const registerOrderStatus = (orderuuid) => {
    return async (dispatch) => {

        const createdAt = FirebaseTimestamp.now()

        const orderStatusData = {
            orderId: orderuuid,
            status: "注文準備中",
            createdAt: createdAt,
        }

        db.collection('OrderStatus').doc(orderuuid).set(orderStatusData)
            .then(() => {
                //console.log('success to register order status');
            })
    }
}